// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.approval-pdf-page {
	height: auto;
	box-sizing: border-box;
	border-radius: 8px;
	display: flex;
}
.approval-pdf-sign {
	position: absolute;
	color: black;
}
.approval-pdf_container {
	position: relative;
	width: -webkit-max-content;
	width: max-content;
}

.pagedevide {
	position: absolute;
	left: 0;
	bottom: 0;
	border-bottom: 1px solid #ccc;
	z-index: 9;
	width: 100%;
}

.custom-scrollbar {
	overflow: auto;
	position: relative;
	border-radius: 8px;
	width: 100%;
}

.custom-scrollbar::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
	background-color: #888;
	border-radius: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
	background-color: #f1f1f1;
	border-bottom-right-radius: 8px;
	border-top-right-radius: 8px;
	border-bottom-left-radius: 8px;
}

.custom-scrollbar::-webkit-scrollbar-corner {
	background-color: transparent;
}

.pdfpreview-container {
	display: flex;
	justify-content: center;
}

.RightSideDetails::-webkit-scrollbar {
	display: none;
}

.RightSideDetails {
	scrollbar-width: none;
	-ms-overflow-style: none;
	padding: 20px 5px 20px 20px;
	overflow: auto;
}

.pdfListView {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	transition: width 0.5s ease-in-out;
}

.pdfDetailsList {
	transition: width 0.5s ease-out;
	top: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Dashboard/OrganizationDashboard/pdf-details.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,0BAAkB;CAAlB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,6BAA6B;CAC7B,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,4BAA4B;CAC5B,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,wBAAwB;CACxB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,kBAAkB;CAClB,kCAAkC;AACnC;;AAEA;CACC,+BAA+B;CAC/B,MAAM;CACN,QAAQ;CACR,mBAAmB;CACnB,gBAAgB;AACjB","sourcesContent":[".approval-pdf-page {\n\theight: auto;\n\tbox-sizing: border-box;\n\tborder-radius: 8px;\n\tdisplay: flex;\n}\n.approval-pdf-sign {\n\tposition: absolute;\n\tcolor: black;\n}\n.approval-pdf_container {\n\tposition: relative;\n\twidth: max-content;\n}\n\n.pagedevide {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\tborder-bottom: 1px solid #ccc;\n\tz-index: 9;\n\twidth: 100%;\n}\n\n.custom-scrollbar {\n\toverflow: auto;\n\tposition: relative;\n\tborder-radius: 8px;\n\twidth: 100%;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n\tbackground-color: #888;\n\tborder-radius: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n\tbackground-color: #f1f1f1;\n\tborder-bottom-right-radius: 8px;\n\tborder-top-right-radius: 8px;\n\tborder-bottom-left-radius: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-corner {\n\tbackground-color: transparent;\n}\n\n.pdfpreview-container {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.RightSideDetails::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.RightSideDetails {\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n\tpadding: 20px 5px 20px 20px;\n\toverflow: auto;\n}\n\n.pdfListView {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tposition: relative;\n\ttransition: width 0.5s ease-in-out;\n}\n\n.pdfDetailsList {\n\ttransition: width 0.5s ease-out;\n\ttop: 0;\n\tright: 0;\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
